import { render, staticRenderFns } from "./WorkflowTransitionActionDeleteOption.vue?vue&type=template&id=28f0c88d&"
import script from "./WorkflowTransitionActionDeleteOption.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransitionActionDeleteOption.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports